module.exports = __webpack_public_path__ + "static/media/appIcon.a3a3e2ea.png";